module.exports = __webpack_public_path__ + "bc1bd82f234d183cb551b3e1102a92a5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/fair/business1.png
// module id = ./assets/images/fair/business1.png
// module chunks = 0